import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'
import Routed from './Router';
import ErrorBoundary from './dev/common/ErrorBoundary'
import '../src/Loader.css'
import 'antd/dist/antd.min.css'
import Loader from './dev/menu/Ui/loader';
import { LoginContextProvider } from './dev/login/LoginContext';

const Login = lazy(() => import('./dev/login/Login'));
const ForgotPassword = lazy(() => import('./dev/login/ForgotPassword'));

function App() {

	const pathname = window.location.pathname;
	if(pathname === '/' || pathname === '/login'){
		localStorage.removeItem("main_task");
		localStorage.removeItem("sub_tasks");
	}
	return (
		<>
			<div className='Loaders' id='loading'>
				<div className="spinL">
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>
			<div className='App'>
				<Suspense fallback={<center style={{margin: "40vh 40%"}}><Loader/></center>}>
				<LoginContextProvider >
					<Routes>
						<Route exact path="/" element={<Navigate exact to="/login" />} />
						<Route path="/login" element={<ErrorBoundary><Login /></ErrorBoundary>} />
						<Route path="/forgot-pw" element={<ErrorBoundary><ForgotPassword /></ErrorBoundary>} />
					</Routes>
				</LoginContextProvider>

				</Suspense>
				{pathname !== '/' && pathname !== '/login' && pathname !== '/forgot-pw' ? <Routed/> : null}
			</div>
		</>
	);
}

export default App;
